
import Vue from 'vue'
import axios from 'axios'

if (process.env.NODE_ENV == 'development') {
  // LOCAL.
  axios.defaults.baseURL = 'http://127.0.0.1:6006/'
} else {  
  // GCLOUD.
  axios.defaults.baseURL = 'https://us-central1-crono-ipog.cloudfunctions.net/cronoipogAPI/'
}

if (localStorage.miolocat) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.miolocat}`
}

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios
  }
})
